import React, { useEffect } from 'react';
import { SiteSettings } from '../types';

interface AdSenseScriptProps {
    settings: SiteSettings;
    currentPath?: string;
}

const AdSenseScript: React.FC<AdSenseScriptProps> = ({ settings, currentPath }) => {
    useEffect(() => {
        if (!settings.enableAdSense || !settings.adSenseClientId) return;

        // Garantimos que o script do AdSense seja carregado exatamente uma vez na cabeça (head) do site.
        // Nunca removemos ou reinjetamos o script durante transições de rota SPA, evitando travamentos,
        // lentidão e vazamentos de memória (memory leaks) decorrentes da reinicialização do motor do Google.
        const scriptId = 'google-adsense-script';
        let script = document.getElementById(scriptId) as HTMLScriptElement;

        if (!script) {
            try {
                script = document.createElement('script');
                script.id = scriptId;
                script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${settings.adSenseClientId}`;
                script.async = true;
                script.crossOrigin = "anonymous";
                document.head.appendChild(script);
            } catch (e) {
                console.error('Erro ao injetar script do AdSense:', e);
            }
        } else {
            // Se o script já existe mas o ID do cliente mudou nas configurações, atualizamos a URL
            const currentSrc = script.src;
            if (!currentSrc.includes(settings.adSenseClientId)) {
                script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${settings.adSenseClientId}`;
            }
        }
    }, [settings.enableAdSense, settings.adSenseClientId]); // Depende apenas de configurações, NUNCA do caminho (route changes)!

    return null;
};

export default AdSenseScript;
